module.exports = __webpack_public_path__ + "img/6.8f418462.jpg";